import React, { useEffect, useState } from 'react';
import queryString from "query-string";
import { Stack, StackItem, Image } from '@fluentui/react';
import LoaderComponent from '../../components/loader/loader.component';
import ErrorMessageComponent from '../../components/error-message/error-message.component';
import SuccessMessageComponent from '../../components/success-message/success-message.component';

import ApiService from '../../services/api/api.service';
import { IApiServiceResponse } from '../../services/api/api.service.response';

import logo from '../../assets/logo-mymov-coral.png';

interface ITokenExecutePageProps {};

const TokenExecutePage = (props: ITokenExecutePageProps) => {
    const [token, setToken] = useState<string>();
    const [loading, setLoading] = useState<boolean>(true);
    const [error, setError] = useState<string>("");
    const [success, setSuccess] = useState<string>("");

    useEffect(() => {
        let queryParams : queryString.ParsedQuery<string> = queryString.parse(window.location.search);
        setToken(queryParams.ItemToken?.toString() || "");
    }, []);

    useEffect(() => {
        if (token) {
            setLoading(true);
            ApiService.Token({
                Token: token,
            }).then((response: IApiServiceResponse<string>) => {
                if (!response.Datos) {
                    setSuccess(response.Mensaje);
                    setLoading(false);
                }
                else {
                    window.location.replace(response.Datos);
                }
            }, (error: string) => {
                setError(error);
                setLoading(false);
            });
        }
    }, [token]);

    return (
        <div className="container-fluid h-100 p-0">
            <Stack 
                horizontal={true}
                className='row align-items-center m-0 h-100'>
                <StackItem className='col-12 col-lg-5 p-5 p-lg-2 p-xl-5 h-100 overflow-auto d-flex flex-column justify-content-between mx-auto'>
                    <div className='d-flex flex-column flex-fill justify-content-center'>
                        <div className='mb-3'>
                            <Image
                                height="90px"
                                src={logo}
                                alt="Logo" />
                        </div>
                        {
                            !loading && error ? (
                                <ErrorMessageComponent message={error} />
                            ) : (
                                null
                            )
                        }
                        {
                            !loading && success ? (
                                <SuccessMessageComponent message={success} isHtml={true} />
                            ) : (
                                null
                            )
                        }
                    </div>
                </StackItem>
            </Stack>
            <LoaderComponent 
                loading={loading}
                text="Estamos procesando tu petición, por favor espera …." />
        </div>
    );
};

export default TokenExecutePage;
